import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Skeleton from "@components/skeleton";

import strings from "../../../../locales/strings";

import defaultFirm from "./images/default_firm_img.svg";

import styles from "./FirmAvatar.scss";

const cx = classnames.bind(styles);

const imgStates = {
  NONE: "none",
  LOADED: "loaded",
  ERROR: "error",
};

const FirmAvatar = ({ firmId, baseUrl }) => {
  const avatarSrc = `https://api.${baseUrl}/v2/avatars/${firmId}`;

  const [imgState, setImgState] = useState(imgStates.NONE);

  return (
    <>
      <img
        loading="lazy"
        src={imgState === imgStates.ERROR ? defaultFirm : avatarSrc}
        className={cx("firm-avatar", imgState === imgStates.NONE && "hidden")}
        alt={strings.avatar}
        data-name="avatar"
        onLoad={() => {
          if (imgState === imgStates.NONE) setImgState(imgStates.LOADED);
        }}
        onError={() => {
          if (imgState === imgStates.NONE) setImgState(imgStates.ERROR);
        }}
      />
      {imgState === imgStates.NONE && (
        <Skeleton
          className={cx("avatar-skeleton")}
          width={50}
          height={50}
          borderRadius={4}
        />
      )}
    </>
  );
};

FirmAvatar.propTypes = {
  firmId: PropTypes.string,
  baseUrl: PropTypes.string,
};

export default FirmAvatar;
